/* Calmy cards: desktop quick add + native product recommendations loader */
(function () {
  'use strict';

  /* ---------- The card's cart button ----------------------------------------
     ONE RULE: never post a variant the customer did not choose.

     A card knows one of three things about its product, and the button does a
     different thing for each:

       data-variant-id present   exactly one purchasable variant and nothing to
                                 choose - post it to /cart/add.js
       no id, a handle           a card built in JavaScript (search
                                 suggestions), which cannot know: ask
                                 /products/<handle>.js once, then fall into one
                                 of the other two branches
       no id, no handle          there is a size or a finish to settle, or the
                                 product is sold out - open the product page,
                                 where the real selector and the waitlist bar
                                 are

     The add goes through window.fetch on purpose: Kaching patches fetch to
     intercept /cart/add.js and expand its bundles, so a request made any other
     way would skip the app entirely. Afterwards Calmy.refreshCart decides what
     the cart does - under Kaching it updates the header count and leaves the
     app's drawer to the app, exactly as the product form already does. */

  var ADD = '[data-calmy-cardadd]';

  function state(btn, name, ms) {
    if (name) btn.setAttribute('data-state', name);
    else btn.removeAttribute('data-state');
    if (ms) setTimeout(function () {
      if (btn.getAttribute('data-state') === name) btn.removeAttribute('data-state');
    }, ms);
  }

  function release(btn) {
    btn.__calmyBusy = false;
    btn.disabled = false;
    btn.removeAttribute('aria-busy');
  }

  function goToProduct(btn) {
    var url = btn.getAttribute('data-product-url');
    if (url) window.location.href = url;
  }

  function addVariant(btn, id) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: id, quantity: 1 })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        release(btn);
        if (!res.ok) { state(btn, 'error', 2400); return; }
        state(btn, 'done', 1800);
        if (window.Calmy && window.Calmy.refreshCart) return window.Calmy.refreshCart(true);
        return fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            document.querySelectorAll('[data-calmy-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
          });
      })
      .catch(function () { release(btn); state(btn, 'error', 2400); });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest(ADD);
    if (!btn) return;

    /* The card's link is a sibling of this button and the rail it may sit in
       scrolls natively, but stopping here costs nothing and means no handler
       added later can treat this press as a press on the card. */
    e.preventDefault();
    e.stopPropagation();

    if (!window.fetch) return goToProduct(btn);
    /* DOUBLE PRESS. disabled alone is not enough: the flag is set before the
       first await and cleared only when the request has settled. */
    if (btn.__calmyBusy) return;

    var id = btn.getAttribute('data-variant-id');
    var handle = btn.getAttribute('data-product-handle');

    if (!id && !handle) return goToProduct(btn);

    btn.__calmyBusy = true;
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    state(btn, 'busy');

    if (id) return addVariant(btn, id);

    fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var vs = (p && p.variants) || [];
        var live = vs.filter(function (v) { return v.available; });
        /* One variant and one only. Two available sizes is a choice, and a
           choice belongs to the customer. */
        if (vs.length === 1 && live.length === 1) {
          btn.setAttribute('data-variant-id', live[0].id);
          return addVariant(btn, live[0].id);
        }
        release(btn);
        state(btn, null);
        goToProduct(btn);
      })
      .catch(function () { release(btn); state(btn, null); goToProduct(btn); });
  });

  /* ---------- Native product recommendations ----------
     Real recommendations always win. Any theme-editor preview markup already in the
     container is only replaced when the endpoint actually returns products. */
  function loadRecs() {
    document.querySelectorAll('[data-calmy-recs]').forEach(function (el) {
      if (el.__calmyLoaded) return;
      el.__calmyLoaded = true;
      var url = el.getAttribute('data-url');
      if (!url || !window.fetch) return;
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-calmy-recs]');
          if (fresh && fresh.querySelector('.ccar')) el.innerHTML = fresh.innerHTML;
        })
        .catch(function () { /* keep whatever is already rendered */ });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', loadRecs);
  else loadRecs();
  document.addEventListener('shopify:section:load', loadRecs);
})();
